import request from '@/utils/request'


// 查询用户拉新渠道列表
export function listInviteChannel(query) {
  return request({
    url: '/biz/admin/user/invite/channel/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询用户拉新渠道分页
export function pageInviteChannel(query) {
  return request({
    url: '/biz/admin/user/invite/channel/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询用户拉新渠道详细
export function getInviteChannel(data) {
  return request({
    url: '/biz/admin/user/invite/channel/detail',
    method: 'get',
    params: data
  })
}

// 审核用户拉新渠道
export function auditInviteChannel(data) {
  return request({
    url: '/biz/admin/user/invite/channel/audit',
    method: 'post',
    data: data
  })
}

// 删除用户拉新渠道
export function delInviteChannel(data) {
  return request({
    url: '/biz/admin/user/invite/channel/delete',
    method: 'post',
    data: data
  })
}

// 获取用户拉新渠道分享链接（用于生成二维码）
export function shareInviteChannel(data) {
  return request({
    url: '/biz/admin/user/invite/channel/share',
    method: 'get',
    params: data
  })
}

// 查询渠道推广人列表
export function pageInviteRecord(query) {
  return request({
    url: '/biz/admin/user/invite/record/list',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 用户拉新统计列表
export function pageInviteUser(query) {
  return request({
    url: '/biz/admin/user/invite/user/list',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}
